import { RouteConfig } from "vue-router";

export const REmployerEmployeesTemplateDocumentsBrowse: RouteConfig = {
  path: "",
  component: () =>
    import(
      /* webpackChunkName: "employer-employee-template-documents-browse" */
      "./VEmployerEmployeesTemplateDocumentsBrowse.vue"
    ),
};
